import { modules } from '@veritone/glc-redux';
const {
  config: { getConfig },
} = modules;

const getEngineIdExportDesktop = (state: any) => {
  const config = getConfig<Window['config']>(state);
  return config.engineIdExportDesktop;
};
export default getEngineIdExportDesktop;
